module.exports = __webpack_public_path__ + "static/1-e973219bdce90d5d42c0c2b96479b80b.jpg";